var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560059 6.51001C0.560059 6.27001 0.653392 6.07001 0.840059 5.91001L6.00006 0.75001C6.16006 0.59001 6.35339 0.51001 6.58006 0.51001C6.80673 0.51001 7.00673 0.59001 7.18006 0.75001C7.35339 0.91001 7.44006 1.11001 7.44006 1.35001C7.44006 1.59001 7.34672 1.79001 7.16006 1.95001L2.60006 6.51001L7.16006 11.07C7.32006 11.23 7.40006 11.43 7.40006 11.67C7.40006 11.91 7.32006 12.11 7.16006 12.27C7.00006 12.43 6.80673 12.51 6.58006 12.51C6.35339 12.51 6.16006 12.43 6.00006 12.27L0.840059 7.11001C0.653392 6.95001 0.560059 6.75001 0.560059 6.51001Z",
    fill: "#050B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.f16ad0c7e153b9376d2ffbbf0f429a59.svg";
export { ForwardRef as ReactComponent };